import * as React from "react";

function BasicInformation({ isMobile = false }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <p className="text-xs text-white font-bold mt-2 ml-3">
            Nacimiento:
        </p>
        
        <p className="text-xs text-main mt-2">
            23/10/1995
        </p>

        <p className="text-xs text-white font-bold ml-3 mt-[-5px]">
          Estado civil:
        </p>
        
        <p className="text-xs text-main mt-[-5px]">
            Soltero
        </p>

        <p className="text-xs text-white font-bold mt-[-5px] ml-3">
          Residencia:
        </p>
        <p className="text-xs text-main mt-[-5px]"> Coyoacán , CDMX </p>
      </div>
    </>
  );
}

export default BasicInformation;
